// Edit website text here. Keep the same keys for de, en, ru, and bg.
const de = {
  meta: {
    homeTitle: "Zahnarztpraxis Dr. Ivanka Barashka | Frankfurt am Main",
    homeDescription:
      "Ihre moderne Zahnarztpraxis im Herzen von Frankfurt. Schmerzfreie Behandlungen, Zahnästhetik, Implantologie und mehr. Seit 2003 auf der Zeil.",
    impressumTitle: "Impressum | Zahnarztpraxis Dr. Barashka",
    datenschutzTitle: "Datenschutz | Zahnarztpraxis Dr. Barashka",
    serviceTitle: "{{title}} | Zahnarztpraxis Dr. Barashka Frankfurt",
  },
  brand: {
    doctorName: "Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
    subtitle: "Zahnarztpraxis Frankfurt",
    footerSubtitle: "Zahnarztpraxis Frankfurt am Main",
    headerPracticeName: "Zahnarztpraxis Frankfurt",
    headerDoctors: "Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
  },
  nav: {
    practice: "Unsere Praxis",
    services: "Leistungen",
    team: "Team",
    testimonials: "Bewertungen",
    contact: "Kontakt",
  },
  common: {
    bookAppointment: "Termin vereinbaren",
    bookingUrl:
      "https://www.doctolib.de/zahnarztpraxis/frankfurt-am-main/zahnarztpraxis-dr-med-dent-ivanka-barashka/booking/motives",
    learnMore: "Mehr erfahren",
    allServices: "Alle Leistungen",
    callNow: "Jetzt anrufen",
    contactNow: "Kontakt aufnehmen",
    languageLabel: "Sprache",
    rightsReserved: "Alle Rechte vorbehalten.",
    moreServices: "Weitere Leistungen",
    advantages: "Ihre Vorteile",
    showAll: "Alle anzeigen",
  },
  hero: {
    eyebrow: "Seit 2003 in Frankfurt am Main",
    titlePrefix: "Willkommen bei",
    titleHighlight: "Team Barashka",
    description:
      "Hier trifft Erfahrung auf Innovation in einer perfekten Kombination. Ihre Zahngesundheit in besten Händen - einfühlsam, schmerzfrei und mit modernsten Methoden.",
    badges: [
      "Angstpatienten willkommen",
      "Schmerzfreie Behandlung",
      "Mehrsprachig",
    ],
  },
  about: {
    eyebrow: "Unsere Praxis",
    title: "Ihre Zahngesundheit in den besten Händen",
    paragraphs: [
      "Am 1. Oktober 2003 wurde unsere Praxis gegründet. Seit diesem Zeitpunkt bemühen wir uns, allen Patienten so schnell wie möglich zu helfen und mit den besten und innovativsten Methoden zu versorgen.",
      "Unsere Zahnarztpraxis ist auf schmerzlose und einfühlsame Behandlungen spezialisiert, sodass alle Patienten sich bei uns wohl fühlen. Wir legen viel Wert auf hochwertige Zahnästhetik und liefern Top-Qualität auf den Gebieten Zahnästhetik, Zahnvorsorge, Zahnerhalt, Implantologie sowie vollkeramischer Zahnersatz.",
      "In unserer Praxis ist es selbstverständlich, dass auch Kinder spielerisch, schmerz- und angstfrei behandelt werden.",
    ],
    experienceValue: "20+",
    experienceLabel: "Jahre Erfahrung",
    features: [
      {
        id: "heart",
        title: "Einfühlsame Behandlung",
        description:
          "Spezialisiert auf schmerzlose Behandlungen, besonders für Angstpatienten.",
      },
      {
        id: "sparkles",
        title: "Modernste Methoden",
        description:
          "Innovative Technologien und hochwertige Materialien für beste Ergebnisse.",
      },
      {
        id: "shield",
        title: "Top-Qualität seit 2003",
        description:
          "Über 20 Jahre Erfahrung in Zahnästhetik, Implantologie und Prothetik.",
      },
      {
        id: "globe",
        title: "Mehrsprachig",
        description: "Wir sprechen Deutsch, Englisch, Russisch und Bulgarisch.",
      },
    ],
  },
  services: {
    eyebrow: "Leistungen",
    title: "Unser Behandlungsspektrum",
    description:
      "Von der Vorsorge bis zur Implantologie - wir bieten Ihnen ein umfassendes Spektrum modernster Zahnmedizin.",
    items: {
      zahnreinigung: {
        title: "Professionelle Zahnreinigung",
        subtitle: "Vorsorge und Prophylaxe",
        cardDescription:
          "Hauptbestandteil der Individualprophylaxe, um Karies und Parodontitis vorzubeugen. Mittels Ultraschall und AirFlow.",
        description: [
          "Die professionelle Zahnreinigung (PZR) ist der Hauptbestandteil der Individualprophylaxe. Sie dient der Vorbeugung von Karies und Parodontitis. Dabei werden mittels Ultraschall und AirFlow hartnäckige Beläge und Verfärbungen entfernt, die beim täglichen Zähneputzen nicht erreicht werden.",
          "Das Ergebnis ist ein spürbar sauberes und frisches Mundgefühl. Regelmäßige professionelle Zahnreinigungen tragen wesentlich zur Erhaltung Ihrer Zahngesundheit bei und können kostspielige Behandlungen vermeiden.",
        ],
        benefits: [
          "Entfernung von Zahnstein und Belägen",
          "Vorbeugung gegen Karies und Parodontitis",
          "Reinigung mit Ultraschall und AirFlow",
          "Politur und Fluoridierung",
          "Individuelle Mundhygiene-Beratung",
          "Frisches, sauberes Mundgefühl",
        ],
        details: [
          "Wir empfehlen eine professionelle Zahnreinigung mindestens zweimal im Jahr.",
          "Die Behandlung dauert in der Regel 45-60 Minuten und ist schmerzfrei.",
        ],
      },
      zahnversiegelung: {
        title: "Zahnversiegelung",
        subtitle: "Kariesprophylaxe",
        cardDescription:
          "Beschichtung der Zahnfissuren mit einer dünnen Kunststoffschicht zum vorbeugenden Schutz vor Karies.",
        description: [
          "Unter einer Zahnversiegelung versteht man eine Beschichtung der Zähne mittels einer dünnen Schicht aus Kunststoff, um sie vor Karies zu schützen. In der Regel werden die Zahnfissuren versiegelt - die Einkerbungen auf der Kaufläche.",
          "Im Gegensatz zur Füllungstherapie wird die Versiegelung vorbeugend angewandt, bevor ein kariöser Defekt eines Zahnes entstanden ist. So lassen sich besonders kariesanfällige Bereiche langfristig schützen.",
        ],
        benefits: [
          "Effektiver Schutz der Zahnfissuren",
          "Vorbeugung gegen Karies",
          "Schnelle und schonende Behandlung",
          "Besonders sinnvoll bei Kindern und Jugendlichen",
          "Erhalt gesunder Zahnsubstanz",
          "Langfristige Prophylaxe",
        ],
        details: [
          "Die Behandlung ist schmerzfrei und dauert meist nur wenige Minuten pro Zahn.",
          "Regelmäßige Kontrollen stellen sicher, dass die Versiegelung intakt bleibt.",
        ],
      },
      knirscherschienen: {
        title: "Knirscherschienen",
        subtitle: "Schutz bei Zähneknirschen",
        cardDescription:
          "Individuell angepasste Schienen zum Schutz vor Abnutzung, Verspannungen und Beschwerden durch Pressen und Knirschen.",
        description: [
          "Knirscherschienen helfen bei Abnutzungen der Zähne sowie bei Knirschen oder Pressen der Zähne. Sie schützen die Zahnsubstanz und entlasten Kiefergelenk und Muskulatur während der Nacht.",
          "Auch bei häufigen Kopfschmerzen, Verspannungen und Schmerzen im Kopf-Hals-Bereich kann eine Schiene die Beschwerden spürbar reduzieren. Besonders bei umfangreichen Keramik-Versorgungen dient sie als zusätzlicher Schutz.",
        ],
        benefits: [
          "Schutz vor weiterem Zahnabrieb",
          "Entlastung von Kiefergelenk und Kaumuskulatur",
          "Unterstützung bei Kopfschmerzen durch Bruxismus",
          "Reduktion von Verspannungen im Kopf-Hals-Bereich",
          "Schonung hochwertiger Keramik-Versorgungen",
          "Individuell angepasster Tragekomfort",
        ],
        details: [
          "Die Schiene wird individuell für Sie angefertigt und regelmäßig kontrolliert.",
          "Anpassungen sind möglich, damit die Schiene dauerhaft gut sitzt.",
        ],
      },
      harmonieschiene: {
        title: "Harmonieschiene",
        subtitle: "Unauffällige Zahnkorrektur",
        cardDescription:
          "Transparente Schienentherapie zur sanften Korrektur leichter bis mittlerer Zahnfehlstellungen.",
        description: [
          "Die Harmonieschiene ist eine ästhetische Möglichkeit, leichte bis mittlere Zahnfehlstellungen schonend zu korrigieren. Die transparenten Schienen sind im Alltag meist kaum sichtbar.",
          "Die Zahnbewegung erfolgt schrittweise über mehrere Schienen. So lässt sich das Lächeln sanft verbessern, ohne den Einsatz klassischer fester Zahnspangen.",
        ],
        benefits: [
          "Unauffällige, transparente Schienen",
          "Sanfte Korrektur von Zahnfehlstellungen",
          "Herausnehmbar im Alltag",
          "Planbarer Behandlungsverlauf",
          "Verbesserte Ästhetik des Lächelns",
          "Komfortable Alternative zu festen Apparaturen",
        ],
        details: [
          "Ob eine Harmonieschiene geeignet ist, klären wir in einer individuellen Beratung.",
          "Regelmäßige Kontrollen begleiten den Therapieverlauf.",
        ],
      },
      implantate: {
        title: "Implantate",
        subtitle: "Fester Zahnersatz",
        cardDescription:
          "Künstliche Zahnwurzeln, die fest im Kieferknochen verankert werden. Natürliches Gefühl und keine Einschränkungen.",
        description: [
          "Zahnimplantate sind künstliche Zahnwurzeln, die fest im Kieferknochen verankert werden. Sie bieten ein natürliches Gefühl und keine Einschränkungen beim Essen, Sprechen oder Lachen. Mit modernsten Materialien und Techniken sorgen wir für eine sichere und langlebige Lösung.",
          "Im Gegensatz zu herkömmlichen Brücken müssen bei Implantaten keine gesunden Nachbarzähne beschliffen werden. Das Implantat verwächst mit dem Knochen und bietet damit einen festen Halt für Kronen, Brücken oder Prothesen.",
        ],
        benefits: [
          "Natürliches Gefühl und Aussehen",
          "Keine Einschränkungen im Alltag",
          "Schonung der Nachbarzähne",
          "Langlebig und stabil",
          "Verhinderung von Knochenabbau",
          "Fester Halt für Zahnersatz",
        ],
      },
      bleaching: {
        title: "Bleaching",
        subtitle: "Zahnaufhellung",
        cardDescription:
          "Professionelle Zahnaufhellung bis zu neun Farbstufen. Zähne erhalten ihre ursprüngliche Farbe zurück.",
        description: [
          "Mit professionellem Bleaching können Ihre Zähne bis zu neun Farbstufen aufgehellt werden. Verfärbungen durch Kaffee, Tee, Rotwein oder Nikotin gehören der Vergangenheit an. Ihre Zähne erhalten ihre ursprüngliche, natürlich helle Farbe zurück.",
          "Wir verwenden schonende und bewährte Bleaching-Verfahren, die den Zahnschmelz nicht angreifen. Das Ergebnis ist ein strahlendes, natürlich wirkendes Lächeln.",
        ],
        benefits: [
          "Aufhellung bis zu neun Farbstufen",
          "Schonend für den Zahnschmelz",
          "Natürlich wirkendes Ergebnis",
          "Schnell sichtbare Resultate",
          "Individuelle Farbberatung",
          "Langanhaltende Wirkung",
        ],
      },
      veneers: {
        title: "Veneers",
        subtitle: "Keramik-Verblendschalen",
        cardDescription:
          "Hauchdünne Keramik-Verblendschalen für ein perfektes Lächeln. Verschönern Ungleichheiten und kleine Lücken.",
        description: [
          "Veneers sind hauchdünne Keramik-Verblendschalen, die auf die Vorderseite der Zähne aufgebracht werden. Sie sind die ideale Lösung, um Ungleichheiten, Verfärbungen, kleine Lücken oder leichte Fehlstellungen zu korrigieren und ein perfektes Lächeln zu schaffen.",
          "Die individuell angefertigten Verblendschalen werden mit einem speziellen Klebeverfahren dauerhaft befestigt. Das Ergebnis ist ein natürlich aussehendes, makelloses Lächeln, das jahrelang hält.",
        ],
        benefits: [
          "Perfektes ästhetisches Ergebnis",
          "Hauchdünne Keramikschalen",
          "Korrektur von Ungleichheiten",
          "Schließen kleiner Zahnlücken",
          "Natürlich aussehendes Ergebnis",
          "Langlebig und lichtdurchlässig",
        ],
      },
      parodontitis: {
        title: "Parodontitis-Behandlung",
        subtitle: "Zahnfleischgesundheit",
        cardDescription:
          "Früherkennung und spezielle Behandlung mittels moderner Methoden. Regelmäßige Kontrolle für optimale Ergebnisse.",
        description: [
          "Parodontitis ist eine entzündliche Erkrankung des Zahnhalteapparats, die unbehandelt zum Zahnverlust führen kann. Durch regelmäßige Kontrollen und moderne Behandlungsmethoden können wir Parodontitis frühzeitig erkennen und effektiv behandeln.",
          "Unsere spezialisierte Parodontitis-Behandlung umfasst die gründliche Reinigung der Zahnfleischtaschen und bei Bedarf chirurgische Eingriffe. Regelmäßige Nachsorge sichert den langfristigen Erfolg der Behandlung.",
        ],
        benefits: [
          "Früherkennung durch regelmäßige Kontrolle",
          "Moderne Behandlungsmethoden",
          "Gründliche Taschenreinigung",
          "Erhalt des Zahnhalteapparats",
          "Individuelle Nachsorge",
          "Vermeidung von Zahnverlust",
        ],
      },
      "kronen-bruecken": {
        title: "Kronen & Brücken",
        subtitle: "Vollkeramischer Zahnersatz",
        cardDescription:
          "Vollkeramischer Zahnersatz für natürliche Ästhetik. Stabilisierung und Korrektur geschädigter Zähne.",
        description: [
          "Kronen und Brücken aus Vollkeramik bieten eine ästhetisch ansprechende und funktionell hochwertige Versorgung. Sie stabilisieren und schützen geschädigte Zähne und ersetzen fehlende Zähne auf natürliche Weise.",
          "Unser vollkeramischer Zahnersatz zeichnet sich durch seine hervorragende Biokompatibilität und seine natürliche Lichtdurchlässigkeit aus. Das Ergebnis sind Zähne, die von natürlichen kaum zu unterscheiden sind.",
        ],
        benefits: [
          "Natürliche Ästhetik durch Vollkeramik",
          "Hervorragende Biokompatibilität",
          "Stabilisierung geschädigter Zähne",
          "Keine dunklen Kronenränder",
          "Individuelle Farbabstimmung",
          "Langlebige, stabile Versorgung",
        ],
      },
      prothesen: {
        title: "Prothesen",
        subtitle: "Teil- und Vollprothesen",
        cardDescription:
          "Herausnehmbarer oder kombinierter Zahnersatz zum zuverlässigen Ersatz fehlender Zähne.",
        description: [
          "Zahnprothesen sind herausnehmbarer oder festsitzender Zahnersatz oder eine Kombination von beiden und werden in Teilprothesen und Vollprothesen eingeteilt.",
          "Teilprothesen ersetzen fehlende Zähne in einem Gebiss, in dem noch Zähne vorhanden sind. Vollprothesen ersetzen ein ganzes Gebiss. Für Funktion und Langlebigkeit empfehlen wir regelmäßige professionelle Kontrollen und Reinigungen.",
        ],
        benefits: [
          "Individuell angepasster Zahnersatz",
          "Teil- oder Vollversorgung möglich",
          "Wiederherstellung von Kaufunktion und Aussprache",
          "Verbesserte Ästhetik im Alltag",
          "Sicherer Halt durch passgenaue Fertigung",
          "Professionelle Pflege und Nachsorge",
        ],
        details: [
          "Prothesen sollten mindestens zwei- bis dreimal pro Jahr zur speziellen Reinigung kontrolliert werden.",
          "Regelmäßige Anpassungen erhöhen den Tragekomfort und die Funktion.",
        ],
      },
      kunststofffuellungen: {
        title: "Kunststofffüllungen",
        subtitle: "Kompositfüllungen",
        cardDescription:
          "Zahnfarbene, stabile Kompositfüllungen für kleinere Defekte im Front- und Seitenzahnbereich.",
        description: [
          "Kunststofffüllungen können bei kleineren Defekten im Front- und Seitenzahnbereich eingesetzt werden, etwa bei kariösen Stellen oder abgebrochenen Schneideflächen. In unserer Praxis verwenden wir vorwiegend hochwertige Kompositfüllungen zum Wiederaufbau der Zahnsubstanz.",
          "Komposit ist ein keramikverstärkter Kunststoff, der stabil, haltbar und biokompatibel ist. Das Material lässt sich farblich an den natürlichen Zahn anpassen und ermöglicht eine minimalinvasive Versorgung.",
        ],
        benefits: [
          "Hohe Zahnästhetik durch zahnfarbene Anpassung",
          "Hohe Festigkeit und lange Lebensdauer",
          "Biokompatibel und gut verträglich",
          "Stabilisierung durch dentinadhäsiven Verbund",
          "Minimalinvasive Kariesbehandlung",
          "Sofort nach der Behandlung belastbar",
        ],
      },
      wurzelbehandlung: {
        title: "Wurzelbehandlung",
        subtitle: "Zahnerhalt durch Endodontie",
        cardDescription:
          "Aufwendige Reinigung und Desinfektion aller Wurzelkanäle unter lokaler Anästhesie. Zahnerhalt statt Verlust.",
        description: [
          "Die Wurzelbehandlung ist eine aufwendige Behandlung zur Rettung eines entzündeten oder abgestorbenen Zahns. Dabei werden alle Wurzelkanäle sorgfältig gereinigt, desinfiziert und anschließend versiegelt.",
          "Dank moderner Techniken und lokaler Anästhesie ist die Wurzelbehandlung heute weitgehend schmerzfrei. Unser Ziel ist es, Ihren natürlichen Zahn zu erhalten und eine Extraktion zu vermeiden.",
        ],
        benefits: [
          "Zahnerhalt statt Extraktion",
          "Schmerzfreie Behandlung",
          "Gründliche Wurzelkanalreinigung",
          "Moderne Desinfektion",
          "Dauerhafte Versiegelung",
          "Erhalt der natürlichen Zahnsubstanz",
        ],
      },
      keramikinlays: {
        title: "Keramikinlays",
        subtitle: "Hochwertige Zahnfüllungen",
        cardDescription:
          "Individuell angefertigte Hightech-Keramik, die dem natürlichen Zahnschmelz sehr ähnlich ist. Langlebig und stabil.",
        description: [
          "Keramikinlays sind individuell angefertigte Einlagefüllungen aus Hightech-Keramik, die dem natürlichen Zahnschmelz in Farbe und Struktur sehr ähnlich sind. Sie bieten eine ästhetisch hochwertige und langlebige Alternative zu herkömmlichen Füllungen.",
          "Die Keramik ist besonders stabil, biokompatibel und verfärbt sich nicht. Durch die exakte Passform wird der Zahn optimal geschützt und seine natürliche Form wiederhergestellt.",
        ],
        benefits: [
          "Natürliche Optik wie echter Zahnschmelz",
          "Hochstabile Keramik",
          "Exakte, individuelle Passform",
          "Biokompatibel und allergiefrei",
          "Keine Verfärbungen",
          "Langlebig und widerstandsfähig",
        ],
      },
    },
  },
  team: {
    eyebrow: "Unser Team",
    title: "Ihre Zahnärztinnen",
    description:
      "Als eingespieltes Mutter-Tochter-Team vereinen wir jahrzehntelange Erfahrung mit frischen Behandlungskonzepten.",
    members: [
      {
        name: "Dr. med. dent. Ivanka Barashka",
        role: "Zahnärztin - Praxisgründerin",
        specialties: [
          "Parodontologie",
          "Implantologie",
          "Ästhetische Zahnmedizin",
        ],
        initials: "IB",
        description:
          "Seit 2003 leitet Dr. Ivanka Barashka die Praxis mit Leidenschaft und Expertise. Ihre Schwerpunkte liegen in der Parodontologie, Endodontologie und ästhetischen Zahnmedizin.",
      },
      {
        name: "Krassimira Baraschka",
        role: "Zahnärztin",
        specialties: [
          "Konservierende Zahnmedizin",
          "Endodontologie",
          "Prophylaxe",
        ],
        initials: "KB",
        description:
          "Krassimira Baraschka ergänzt das Team mit sanften, patientenorientierten Behandlungen. Besonders geschätzt für ihre einfühlsame Art bei Angstpatienten.",
      },
    ],
  },
  testimonials: {
    eyebrow: "Bewertungen",
    title: "Was unsere Patienten sagen",
    description:
      "Wir sind stolz auf das Vertrauen unserer Patienten. Lesen Sie, welche Erfahrungen andere mit unserer Praxis gemacht haben.",
    ratingLabel: "Bewertet auf Jameda",
    items: [
      {
        text: "Zuvor war ich lange nicht beim Zahnarzt. Ich hatte Angst vor dem Zahnarztbesuch. Mit dem netten Team in der Praxis ist das jedoch Geschichte. Nun ist auch meine Mutter eine Patientin hier.",
        date: "Juni 2022",
        source: "Jameda",
      },
      {
        text: "So sanft habe ich das ganz selten erlebt, der Einstich war wirklich kaum zu spüren! Sie gehört nicht zu den Zahnärzten, die unnötig etwas aufschwatzen und sie will auch zahnerhaltend arbeiten.",
        date: "Juni 2020",
        source: "Jameda",
      },
      {
        text: "Schnell, professionell und sorgfältig habe ich mein Lächeln schön gemacht! Ich habe mich ihnen voll und ganz anvertraut und die richtige Wahl getroffen.",
        date: "Juli 2021",
        source: "Jameda",
      },
      {
        text: "Ich gehe zu Dr. Barashka schon seit etwa 10 Jahren und bin auf allen Ebenen vollkommen zufrieden. Nimmt sich immer die Zeit und arbeitet qualitativ und schmerzfrei.",
        date: "August 2019",
        source: "Jameda",
      },
      {
        text: "Wurde sehr freundlich behandelt. Auch meine Fragen zum Risiko von Weisheitszähnen im Alter wurden von beiden Zahnärztinnen ausführlich erörtert, ohne mich zu einer Entscheidung zu drängen.",
        date: "Januar 2022",
        source: "Jameda",
      },
      {
        text: "Nimmt sich in der Regel viel Zeit. Ist um jeden Zahn bemüht, gibt sich viel Mühe.",
        date: "März 2016",
        source: "Jameda",
      },
    ],
  },
  cta: {
    title: "Ihr schönstes Lächeln wartet auf Sie",
    description:
      "Vereinbaren Sie noch heute Ihren Termin und lassen Sie sich unverbindlich beraten. Wir nehmen uns Zeit für Sie.",
  },
  contact: {
    eyebrow: "Kontakt",
    title: "So erreichen Sie uns",
    description:
      "Wir freuen uns auf Ihren Besuch. Vereinbaren Sie Ihren Termin telefonisch oder besuchen Sie uns direkt in unserer Praxis auf der Zeil.",
    cardTitle: "Kontaktdaten",
    addressLabel: "Adresse",
    addressLine1: "Zeil 81 (Eingang Holzgraben)",
    addressLine2: "60313 Frankfurt am Main",
    addressHint: "2. OG mit Fahrstuhl, barrierefrei",
    phoneLabel: "Telefon",
    phoneValue: "069 28 76 50",
    emailLabel: "E-Mail",
    emailValue: "info@zahnarztpraxis-barashka.de",
    hoursTitle: "Öffnungszeiten",
    hours: [
      { day: "Montag", hours: "8:00 - 18:00 Uhr" },
      { day: "Dienstag", hours: "8:00 - 18:00 Uhr" },
      { day: "Mittwoch", hours: "8:00 - 19:00 Uhr" },
      { day: "Donnerstag", hours: "8:00 - 18:00 Uhr" },
      { day: "Freitag", hours: "8:00 - 13:00 Uhr" },
      { day: "Samstag", hours: "Geschlossen", closed: true },
      { day: "Sonntag", hours: "Geschlossen", closed: true },
    ],
    emergency:
      "Notfallkontakt: Bitte kontaktieren Sie bei Notfällen 116117 (Kassenärztlicher Notdienst)",
  },
  footer: {
    description:
      "Seit 2003 Ihre vertrauensvolle Zahnarztpraxis im Herzen von Frankfurt. Moderne Zahnmedizin mit Herz und Verstand.",
    servicesHeading: "Leistungen",
    openingHoursHeading: "Öffnungszeiten",
    contactHeading: "Kontakt",
    openingSummary: [
      { day: "Mo, Di, Do", hours: "8:00 - 18:00" },
      { day: "Mittwoch", hours: "8:00 - 19:00" },
      { day: "Freitag", hours: "8:00 - 13:00" },
      { day: "Sa, So", hours: "Geschlossen", closed: true },
    ],
  },
  servicePage: {
    appointmentTitle: "Termin vereinbaren",
    appointmentDescription:
      "Wir beraten Sie gerne ausführlich zu dieser Behandlung. Rufen Sie uns an oder besuchen Sie uns in unserer Praxis.",
  },
  legal: {
    impressum: {
      title: "Impressum",
      sections: [
        {
          title: "Angaben nach 5 TMG",
          body: [
            "Zahnarztpraxis Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
            "Zeil 81 (Eingang Holzgraben)",
            "60313 Frankfurt am Main",
          ],
        },
        {
          title: "Kontakt",
          body: [
            "Telefon: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "Berufsbezeichnung",
          body: [
            "Zahnärztin (verliehen in der Bundesrepublik Deutschland)",
            "Zuständige Kammer: Landeszahnärztekammer Hessen",
            "Zuständige Aufsichtsbehörde: Kassenzahnärztliche Vereinigung Hessen",
          ],
        },
        {
          title: "Berufsrechtliche Regelungen",
          body: [
            "Zahnheilkundegesetz (ZHG)",
            "Berufsordnung der Landeszahnärztekammer Hessen",
            "Gebührenordnung für Zahnärzte (GOZ)",
          ],
        },
      ],
    },
    datenschutz: {
      title: "Datenschutzerklärung",
      sections: [
        {
          title: "1. Verantwortlicher",
          body: [
            "Verantwortlich für die Datenverarbeitung auf dieser Website ist:",
            "Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
            "Zeil 81 (Eingang Holzgraben), 60313 Frankfurt am Main",
            "Telefon: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "2. Erhebung und Speicherung personenbezogener Daten",
          body: [
            "Beim Besuch unserer Website werden automatisch Informationen durch den Browser übermittelt und in Server-Log-Dateien gespeichert. Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung mit anderen Datenquellen wird nicht vorgenommen.",
          ],
        },
        {
          title: "3. Kontaktaufnahme",
          body: [
            "Wenn Sie uns per Telefon oder E-Mail kontaktieren, werden Ihre Angaben zur Bearbeitung Ihrer Anfrage gespeichert. Eine Weitergabe an Dritte findet nicht statt.",
          ],
        },
        {
          title: "4. Ihre Rechte",
          body: [
            "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Bitte wenden Sie sich an die oben genannte Kontaktadresse.",
          ],
        },
        {
          title: "5. Google Maps",
          body: [
            "Diese Website nutzt Google Maps zur Darstellung unseres Standortes. Beim Aufruf werden Daten an Google übermittelt. Weitere Informationen finden Sie in der Datenschutzerklärung von Google.",
          ],
        },
      ],
    },
  },
}

const en = {
  ...de,
  meta: {
    ...de.meta,
    homeTitle: "Dental Practice Dr. Ivanka Barashka | Frankfurt am Main",
    homeDescription:
      "Your modern dental practice in the heart of Frankfurt. Gentle treatments, cosmetic dentistry, implants and more. Since 2003 on Zeil.",
    impressumTitle: "Legal Notice | Dental Practice Dr. Barashka",
    datenschutzTitle: "Privacy Policy | Dental Practice Dr. Barashka",
    serviceTitle: "{{title}} | Dental Practice Dr. Barashka Frankfurt",
  },
  brand: {
    ...de.brand,
    subtitle: "Dental Practice Frankfurt",
    footerSubtitle: "Dental Practice Frankfurt am Main",
  },
  nav: {
    practice: "Our Practice",
    services: "Services",
    team: "Team",
    testimonials: "Reviews",
    contact: "Contact",
  },
  common: {
    ...de.common,
    bookAppointment: "Book appointment",
    learnMore: "Learn more",
    allServices: "All services",
    callNow: "Call now",
    contactNow: "Contact us",
    languageLabel: "Language",
    rightsReserved: "All rights reserved.",
    moreServices: "More services",
    advantages: "Your benefits",
    showAll: "Show all",
  },
  hero: {
    ...de.hero,
    eyebrow: "Since 2003 in Frankfurt am Main",
    titlePrefix: "Welcome to",
    description:
      "Experience meets innovation in perfect balance. Your dental health in the best hands - caring, gentle and state of the art.",
    badges: ["Anxious patients welcome", "Gentle treatment", "Multilingual"],
  },
  about: {
    ...de.about,
    eyebrow: "Our Practice",
    title: "Your dental health in the best hands",
    paragraphs: [
      "Our practice was founded on October 1, 2003. Since then, we have been committed to helping all patients as quickly as possible and providing them with the best and most innovative methods.",
      "Our dental practice specializes in painless and compassionate treatments, so that all patients feel comfortable with us. We place great value on high-quality dental aesthetics and deliver top quality in the fields of cosmetic dentistry, preventive care, tooth preservation, implantology and all-ceramic tooth replacement.",
      "In our practice, it goes without saying that children are also treated in a playful, pain-free and anxiety-free manner.",
    ],
    experienceLabel: "Years of experience",
    features: [
      {
        id: "heart",
        title: "Compassionate Treatment",
        description:
          "Specialized in painless treatments, especially for anxious patients.",
      },
      {
        id: "sparkles",
        title: "State-of-the-Art Methods",
        description:
          "Innovative technologies and high-quality materials for the best results.",
      },
      {
        id: "shield",
        title: "Top Quality Since 2003",
        description:
          "Over 20 years of experience in cosmetic dentistry, implantology and prosthetics.",
      },
      {
        id: "globe",
        title: "Multilingual",
        description: "We speak German, English, Russian and Bulgarian.",
      },
    ],
  },
  services: {
    ...de.services,
    eyebrow: "Services",
    title: "Our treatment spectrum",
    description:
      "From prevention to implantology - we offer a comprehensive range of modern dental care.",
    items: {
      zahnreinigung: {
        title: "Professional Teeth Cleaning",
        subtitle: "Prevention and Prophylaxis",
        cardDescription:
          "Key component of individual prophylaxis to prevent cavities and periodontal disease. Using ultrasound and AirFlow.",
        description: [
          "Professional teeth cleaning (PZR) is the main component of individual prophylaxis. It serves to prevent cavities and periodontal disease. Using ultrasound and AirFlow, stubborn deposits and discolorations that cannot be reached by daily brushing are removed.",
          "The result is a noticeably clean and fresh feeling in your mouth. Regular professional teeth cleanings contribute significantly to maintaining your dental health and can help avoid costly treatments.",
        ],
        benefits: [
          "Removal of tartar and deposits",
          "Prevention of cavities and periodontal disease",
          "Cleaning with ultrasound and AirFlow",
          "Polishing and fluoride treatment",
          "Individual oral hygiene advice",
          "Fresh, clean feeling in your mouth",
        ],
        details: [
          "We recommend professional teeth cleaning at least twice a year.",
          "The treatment usually takes 45-60 minutes and is painless.",
        ],
      },
      zahnversiegelung: {
        title: "Dental Sealants",
        subtitle: "Cavity Prevention",
        cardDescription:
          "Coating of tooth fissures with a thin layer of plastic for preventive protection against cavities.",
        description: [
          "Dental sealant refers to a coating of the teeth with a thin layer of plastic to protect them from cavities. Typically, the tooth fissures are sealed - the grooves on the chewing surface.",
          "Unlike filling therapy, sealants are applied preventively before a cavity has developed. This allows particularly cavity-prone areas to be protected long-term.",
        ],
        benefits: [
          "Effective protection of tooth fissures",
          "Prevention of cavities",
          "Quick and gentle treatment",
          "Especially beneficial for children and teenagers",
          "Preservation of healthy tooth structure",
          "Long-term prophylaxis",
        ],
        details: [
          "The treatment is painless and usually takes only a few minutes per tooth.",
          "Regular check-ups ensure the sealant remains intact.",
        ],
      },
      knirscherschienen: {
        title: "Night Guards",
        subtitle: "Protection Against Teeth Grinding",
        cardDescription:
          "Individually fitted splints to protect against wear, tension and discomfort caused by clenching and grinding.",
        description: [
          "Night guards help with tooth wear as well as grinding or clenching of teeth. They protect the tooth structure and relieve the jaw joint and muscles during the night.",
          "For frequent headaches, tension and pain in the head and neck area, a splint can noticeably reduce symptoms. For extensive ceramic restorations, it also serves as additional protection.",
        ],
        benefits: [
          "Protection against further tooth wear",
          "Relief of jaw joint and chewing muscles",
          "Support for headaches caused by bruxism",
          "Reduction of tension in the head and neck area",
          "Protection of high-quality ceramic restorations",
          "Individually fitted for comfort",
        ],
        details: [
          "The splint is custom-made for you and regularly checked.",
          "Adjustments are possible to ensure a consistently good fit.",
        ],
      },
      harmonieschiene: {
        title: "Clear Aligners",
        subtitle: "Discreet Teeth Straightening",
        cardDescription:
          "Transparent aligner therapy for gentle correction of mild to moderate dental misalignments.",
        description: [
          "Clear aligners offer an aesthetic way to gently correct mild to moderate dental misalignments. The transparent trays are usually barely visible in everyday life.",
          "Tooth movement occurs gradually through a series of aligners. This allows your smile to be gently improved without the use of traditional fixed braces.",
        ],
        benefits: [
          "Discreet, transparent aligners",
          "Gentle correction of misalignments",
          "Removable for daily life",
          "Predictable treatment progress",
          "Improved smile aesthetics",
          "Comfortable alternative to fixed braces",
        ],
        details: [
          "Whether clear aligners are suitable for you is determined during an individual consultation.",
          "Regular check-ups accompany the treatment process.",
        ],
      },
      implantate: {
        title: "Dental Implants",
        subtitle: "Fixed Tooth Replacement",
        cardDescription:
          "Artificial tooth roots firmly anchored in the jawbone. Natural feeling with no restrictions.",
        description: [
          "Dental implants are artificial tooth roots that are firmly anchored in the jawbone. They provide a natural feeling with no restrictions when eating, speaking or laughing. Using the latest materials and techniques, we ensure a safe and long-lasting solution.",
          "Unlike conventional bridges, implants do not require healthy neighboring teeth to be ground down. The implant fuses with the bone, providing a firm hold for crowns, bridges or dentures.",
        ],
        benefits: [
          "Natural feeling and appearance",
          "No restrictions in daily life",
          "Preservation of neighboring teeth",
          "Long-lasting and stable",
          "Prevention of bone loss",
          "Firm hold for tooth replacement",
        ],
      },
      bleaching: {
        title: "Teeth Whitening",
        subtitle: "Professional Bleaching",
        cardDescription:
          "Professional teeth whitening up to nine shades lighter. Teeth regain their original color.",
        description: [
          "With professional bleaching, your teeth can be whitened by up to nine shades. Discolorations from coffee, tea, red wine or nicotine become a thing of the past. Your teeth regain their original, naturally bright color.",
          "We use gentle and proven whitening methods that do not damage the tooth enamel. The result is a radiant, natural-looking smile.",
        ],
        benefits: [
          "Whitening up to nine shades",
          "Gentle on tooth enamel",
          "Natural-looking results",
          "Quickly visible results",
          "Individual color consultation",
          "Long-lasting effect",
        ],
      },
      veneers: {
        title: "Veneers",
        subtitle: "Ceramic Veneers",
        cardDescription:
          "Ultra-thin ceramic veneers for a perfect smile. Correct irregularities and small gaps.",
        description: [
          "Veneers are ultra-thin ceramic shells that are applied to the front of the teeth. They are the ideal solution for correcting irregularities, discolorations, small gaps or slight misalignments to create a perfect smile.",
          "The individually crafted veneers are permanently bonded using a special adhesive technique. The result is a natural-looking, flawless smile that lasts for years.",
        ],
        benefits: [
          "Perfect aesthetic result",
          "Ultra-thin ceramic shells",
          "Correction of irregularities",
          "Closing of small tooth gaps",
          "Natural-looking result",
          "Long-lasting and translucent",
        ],
      },
      parodontitis: {
        title: "Periodontal Treatment",
        subtitle: "Gum Health",
        cardDescription:
          "Early detection and specialized treatment using modern methods. Regular monitoring for optimal results.",
        description: [
          "Periodontitis is an inflammatory disease of the tooth-supporting structures that can lead to tooth loss if left untreated. Through regular check-ups and modern treatment methods, we can detect and effectively treat periodontitis early.",
          "Our specialized periodontal treatment includes thorough cleaning of the gum pockets and, if necessary, surgical procedures. Regular follow-up care ensures the long-term success of the treatment.",
        ],
        benefits: [
          "Early detection through regular check-ups",
          "Modern treatment methods",
          "Thorough pocket cleaning",
          "Preservation of tooth-supporting structures",
          "Individual follow-up care",
          "Prevention of tooth loss",
        ],
      },
      "kronen-bruecken": {
        title: "Crowns & Bridges",
        subtitle: "All-Ceramic Tooth Replacement",
        cardDescription:
          "All-ceramic tooth replacement for natural aesthetics. Stabilization and restoration of damaged teeth.",
        description: [
          "All-ceramic crowns and bridges offer an aesthetically pleasing and functionally superior restoration. They stabilize and protect damaged teeth and replace missing teeth in a natural way.",
          "Our all-ceramic tooth replacement is distinguished by its excellent biocompatibility and natural translucency. The result is teeth that are virtually indistinguishable from natural ones.",
        ],
        benefits: [
          "Natural aesthetics with all-ceramic",
          "Excellent biocompatibility",
          "Stabilization of damaged teeth",
          "No dark crown margins",
          "Individual color matching",
          "Long-lasting, stable restoration",
        ],
      },
      prothesen: {
        title: "Dentures",
        subtitle: "Partial and Full Dentures",
        cardDescription:
          "Removable or combined tooth replacement for reliable restoration of missing teeth.",
        description: [
          "Dental prostheses are removable or fixed tooth replacements, or a combination of both, and are divided into partial and full dentures.",
          "Partial dentures replace missing teeth where some natural teeth remain. Full dentures replace an entire set of teeth. For function and longevity, we recommend regular professional check-ups and cleanings.",
        ],
        benefits: [
          "Individually fitted tooth replacement",
          "Partial or full restoration possible",
          "Restoration of chewing function and speech",
          "Improved aesthetics in daily life",
          "Secure hold through precision fit",
          "Professional care and follow-up",
        ],
        details: [
          "Dentures should be checked and professionally cleaned at least two to three times per year.",
          "Regular adjustments improve comfort and function.",
        ],
      },
      kunststofffuellungen: {
        title: "Composite Fillings",
        subtitle: "Tooth-Colored Fillings",
        cardDescription:
          "Tooth-colored, stable composite fillings for smaller defects in the front and side tooth areas.",
        description: [
          "Composite fillings can be used for smaller defects in the front and side tooth areas, such as cavities or chipped edges. In our practice, we primarily use high-quality composite fillings to rebuild tooth structure.",
          "Composite is a ceramic-reinforced plastic that is stable, durable and biocompatible. The material can be color-matched to the natural tooth and enables minimally invasive treatment.",
        ],
        benefits: [
          "High dental aesthetics through tooth-colored matching",
          "High strength and long lifespan",
          "Biocompatible and well-tolerated",
          "Stabilization through dentin-adhesive bonding",
          "Minimally invasive cavity treatment",
          "Immediately loadable after treatment",
        ],
      },
      wurzelbehandlung: {
        title: "Root Canal Treatment",
        subtitle: "Tooth Preservation Through Endodontics",
        cardDescription:
          "Thorough cleaning and disinfection of all root canals under local anesthesia. Tooth preservation instead of extraction.",
        description: [
          "Root canal treatment is an extensive procedure to save an inflamed or dead tooth. All root canals are carefully cleaned, disinfected and then sealed.",
          "Thanks to modern techniques and local anesthesia, root canal treatment is largely painless today. Our goal is to preserve your natural tooth and avoid extraction.",
        ],
        benefits: [
          "Tooth preservation instead of extraction",
          "Painless treatment",
          "Thorough root canal cleaning",
          "Modern disinfection",
          "Permanent sealing",
          "Preservation of natural tooth structure",
        ],
      },
      keramikinlays: {
        title: "Ceramic Inlays",
        subtitle: "High-Quality Dental Fillings",
        cardDescription:
          "Individually crafted high-tech ceramic that closely resembles natural tooth enamel. Long-lasting and stable.",
        description: [
          "Ceramic inlays are individually crafted fillings made from high-tech ceramic that closely resemble natural tooth enamel in color and structure. They offer an aesthetically superior and long-lasting alternative to conventional fillings.",
          "The ceramic is particularly stable, biocompatible and does not discolor. The precise fit optimally protects the tooth and restores its natural form.",
        ],
        benefits: [
          "Natural appearance like real tooth enamel",
          "Highly stable ceramic",
          "Precise, individual fit",
          "Biocompatible and allergy-free",
          "No discoloration",
          "Long-lasting and resilient",
        ],
      },
    },
  },
  team: {
    ...de.team,
    eyebrow: "Our Team",
    title: "Your Dentists",
    description:
      "As a well-coordinated mother-daughter team, we combine decades of experience with fresh treatment concepts.",
    members: [
      {
        name: "Dr. med. dent. Ivanka Barashka",
        role: "Dentist - Practice Founder",
        specialties: ["Periodontics", "Implantology", "Cosmetic Dentistry"],
        initials: "IB",
        description:
          "Since 2003, Dr. Ivanka Barashka has led the practice with passion and expertise. Her specialties include periodontics, endodontics and cosmetic dentistry.",
      },
      {
        name: "Krassimira Baraschka",
        role: "Dentist",
        specialties: ["Restorative Dentistry", "Endodontics", "Prophylaxis"],
        initials: "KB",
        description:
          "Krassimira Baraschka complements the team with gentle, patient-oriented treatments. Especially valued for her compassionate approach with anxious patients.",
      },
    ],
  },
  testimonials: {
    ...de.testimonials,
    eyebrow: "Reviews",
    title: "What our patients say",
    description:
      "We are proud of our patients' trust. Read about the experiences others have had at our practice.",
    ratingLabel: "Rated on Jameda",
    items: [
      {
        text: "I hadn't been to the dentist for a long time. I was afraid of going. With the friendly team at the practice, however, that is now history. Now my mother is also a patient here.",
        date: "June 2022",
        source: "Jameda",
      },
      {
        text: "I have rarely experienced anything so gentle — the injection was barely noticeable! She is not one of those dentists who push unnecessary treatments, and she always aims to preserve teeth.",
        date: "June 2020",
        source: "Jameda",
      },
      {
        text: "Quickly, professionally and carefully, my smile was made beautiful! I trusted them completely and made the right choice.",
        date: "July 2021",
        source: "Jameda",
      },
      {
        text: "I have been going to Dr. Barashka for about 10 years now and am completely satisfied on all levels. She always takes the time and works with great quality and painlessly.",
        date: "August 2019",
        source: "Jameda",
      },
      {
        text: "I was treated very kindly. Even my questions about the risks of wisdom teeth in old age were discussed in detail by both dentists, without pressuring me into a decision.",
        date: "January 2022",
        source: "Jameda",
      },
      {
        text: "Usually takes a lot of time. Cares about every tooth and puts in a great deal of effort.",
        date: "March 2016",
        source: "Jameda",
      },
    ],
  },
  cta: {
    ...de.cta,
    title: "Your best smile is waiting",
    description:
      "Book your appointment today and receive a no-obligation consultation. We take the time for you.",
  },
  contact: {
    ...de.contact,
    eyebrow: "Contact",
    title: "How to reach us",
    description:
      "We look forward to your visit. Book your appointment by phone or visit us directly at our practice on Zeil.",
    cardTitle: "Contact details",
    addressLabel: "Address",
    addressLine1: "Zeil 81 (Entrance Holzgraben)",
    addressHint: "2nd floor with elevator, barrier-free",
    phoneLabel: "Phone",
    emailLabel: "Email",
    hoursTitle: "Opening hours",
    hours: [
      { day: "Monday", hours: "8:00 AM - 6:00 PM" },
      { day: "Tuesday", hours: "8:00 AM - 6:00 PM" },
      { day: "Wednesday", hours: "8:00 AM - 7:00 PM" },
      { day: "Thursday", hours: "8:00 AM - 6:00 PM" },
      { day: "Friday", hours: "8:00 AM - 1:00 PM" },
      { day: "Saturday", hours: "Closed", closed: true },
      { day: "Sunday", hours: "Closed", closed: true },
    ],
    emergency:
      "Emergency contact: In case of emergencies, please contact 116117 (emergency dental service)",
  },
  footer: {
    ...de.footer,
    description:
      "Your trusted dental practice in the heart of Frankfurt since 2003. Modern dentistry with heart and expertise.",
    servicesHeading: "Services",
    openingHoursHeading: "Opening hours",
    contactHeading: "Contact",
    openingSummary: [
      { day: "Mon, Tue, Thu", hours: "8:00 AM - 6:00 PM" },
      { day: "Wednesday", hours: "8:00 AM - 7:00 PM" },
      { day: "Friday", hours: "8:00 AM - 1:00 PM" },
      { day: "Sat, Sun", hours: "Closed", closed: true },
    ],
  },
  servicePage: {
    ...de.servicePage,
    appointmentTitle: "Book appointment",
    appointmentDescription:
      "We are happy to advise you in detail about this treatment. Call us or visit us at our practice.",
  },
  legal: {
    impressum: {
      title: "Legal Notice",
      sections: [
        {
          title: "Information according to § 5 TMG",
          body: [
            "Zahnarztpraxis Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
            "Zeil 81 (Entrance Holzgraben)",
            "60313 Frankfurt am Main",
          ],
        },
        {
          title: "Contact",
          body: [
            "Phone: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "Professional Title",
          body: [
            "Dentist (awarded in the Federal Republic of Germany)",
            "Responsible chamber: State Dental Association of Hesse",
            "Responsible supervisory authority: Association of Statutory Health Insurance Dentists Hesse",
          ],
        },
        {
          title: "Professional Regulations",
          body: [
            "Dental Healing Act (ZHG)",
            "Professional Code of the State Dental Association of Hesse",
            "Fee Schedule for Dentists (GOZ)",
          ],
        },
      ],
    },
    datenschutz: {
      title: "Privacy Policy",
      sections: [
        {
          title: "1. Controller",
          body: [
            "The controller for data processing on this website is:",
            "Dr. med. dent. Ivanka Barashka",
            "Zeil 81 (Entrance Holzgraben), 60313 Frankfurt am Main",
            "Phone: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "2. Collection and Storage of Personal Data",
          body: [
            "When you visit our website, information is automatically transmitted by your browser and stored in server log files. This data cannot be attributed to specific individuals. Merging with other data sources is not carried out.",
          ],
        },
        {
          title: "3. Contact",
          body: [
            "If you contact us by phone or email, your details will be stored for the purpose of processing your inquiry. Your data will not be passed on to third parties.",
          ],
        },
        {
          title: "4. Your Rights",
          body: [
            "You have the right to access, rectification, deletion and restriction of processing of your personal data. Please contact the address listed above.",
          ],
        },
        {
          title: "5. Google Maps",
          body: [
            "This website uses Google Maps to display our location. When accessed, data is transmitted to Google. For more information, please refer to Google's privacy policy.",
          ],
        },
      ],
    },
  },
}

const ru = {
  ...de,
  meta: {
    ...de.meta,
    homeTitle: "Стоматология д-ра Иванки Барашки | Франкфурт-на-Майне",
    homeDescription:
      "Современная стоматология в центре Франкфурта. Безболезненное лечение, эстетическая стоматология, имплантация и многое другое.",
    impressumTitle: "Юридическая информация | Стоматология д-ра Барашки",
    datenschutzTitle: "Политика конфиденциальности | Стоматология д-ра Барашки",
    serviceTitle: "{{title}} | Стоматология д-ра Барашки, Франкфурт",
  },
  brand: {
    ...de.brand,
    doctorName: "д-р Иванка Барашка",
    subtitle: "Стоматология Франкфурт",
    footerSubtitle: "Стоматология Франкфурт-на-Майне",
  },
  nav: {
    practice: "О клинике",
    services: "Услуги",
    team: "Команда",
    testimonials: "Отзывы",
    contact: "Контакты",
  },
  common: {
    ...de.common,
    bookAppointment: "Записаться на приём",
    learnMore: "Подробнее",
    allServices: "Все услуги",
    callNow: "Позвонить",
    contactNow: "Связаться",
    languageLabel: "Язык",
    rightsReserved: "Все права защищены.",
    moreServices: "Другие услуги",
    advantages: "Ваши преимущества",
    showAll: "Показать все",
  },
  hero: {
    ...de.hero,
    eyebrow: "С 2003 года во Франкфурте-на-Майне",
    titlePrefix: "Добро пожаловать в",
    titleHighlight: "команду Барашка",
    description:
      "Опыт и инновации в идеальном сочетании. Здоровье ваших зубов в надёжных руках — бережно, безболезненно и с применением современных методов.",
    badges: [
      "Принимаем пациентов со страхом перед лечением",
      "Безболезненное лечение",
      "Говорим на нескольких языках",
    ],
  },
  about: {
    ...de.about,
    eyebrow: "О клинике",
    title: "Здоровье ваших зубов в лучших руках",
    paragraphs: [
      "1 октября 2003 года была основана наша клиника. С тех пор мы стремимся помочь всем пациентам как можно быстрее и обеспечить их лечение лучшими и наиболее инновационными методами.",
      "Наша клиника специализируется на безболезненном и бережном лечении, чтобы каждый пациент чувствовал себя комфортно. Мы уделяем особое внимание эстетической стоматологии и оказываем услуги высокого качества в области профилактики, сохранения зубов, имплантологии и цельнокерамического протезирования.",
      "Мы также лечим детей в игровой форме, без боли и страха.",
    ],
    experienceLabel: "Лет опыта",
    features: [
      {
        id: "heart",
        title: "Чуткое лечение",
        description:
          "Специализируемся на безболезненном лечении, особенно для пациентов с тревожностью.",
      },
      {
        id: "sparkles",
        title: "Современные методы",
        description:
          "Инновационные технологии и высококачественные материалы для лучших результатов.",
      },
      {
        id: "shield",
        title: "Высокое качество с 2003 года",
        description:
          "Более 20 лет опыта в эстетической стоматологии, имплантологии и протезировании.",
      },
      {
        id: "globe",
        title: "Говорим на нескольких языках",
        description:
          "Мы говорим по-немецки, по-английски, по-русски и по-болгарски.",
      },
    ],
  },
  services: {
    ...de.services,
    eyebrow: "Услуги",
    title: "Спектр наших услуг",
    description:
      "От профилактики до имплантации — мы предлагаем полный спектр услуг современной стоматологии.",
    items: {
      zahnreinigung: {
        title: "Профессиональная чистка зубов",
        subtitle: "Профилактика и гигиена",
        cardDescription:
          "Важная часть индивидуальной профилактики кариеса и пародонтита с применением ультразвука и AirFlow.",
        description: [
          "Профессиональная чистка зубов (PZR) является важной частью индивидуальной профилактики кариеса и пародонтита. С помощью ультразвука и AirFlow удаляются стойкие отложения, пигментированный налёт и окрашивания, которые невозможно устранить при ежедневной чистке зубов.",
          "Результат — ощущение чистоты и свежести во рту. Регулярная профессиональная чистка помогает сохранить здоровье зубов и избежать дорогостоящего лечения.",
        ],
        benefits: [
          "Удаление зубного камня и отложений",
          "Профилактика кариеса и пародонтита",
          "Очистка ультразвуком и AirFlow",
          "Полировка и фторирование",
          "Индивидуальная консультация по гигиене полости рта",
          "Ощущение чистоты и свежести во рту",
        ],
        details: [
          "Мы рекомендуем профессиональную чистку зубов не реже двух раз в год.",
          "Процедура обычно длится 45-60 минут и проходит безболезненно.",
        ],
      },
      zahnversiegelung: {
        title: "Герметизация фиссур",
        subtitle: "Профилактика кариеса",
        cardDescription:
          "Нанесение тонкого слоя стоматологического герметика на фиссуры для защиты от кариеса.",
        description: [
          "Герметизация фиссур — это нанесение тонкого слоя стоматологического герметика для защиты зубов от кариеса. Как правило, герметизируются фиссуры — углубления на жевательной поверхности.",
          "В отличие от пломбирования, герметизация применяется профилактически, до возникновения кариозного дефекта зуба. Таким образом, особенно подверженные кариесу участки защищаются надолго.",
        ],
        benefits: [
          "Эффективная защита фиссур зубов",
          "Профилактика кариеса",
          "Быстрая и щадящая процедура",
          "Особенно полезна для детей и подростков",
          "Сохранение здоровой зубной ткани",
          "Долгосрочная профилактика",
        ],
        details: [
          "Процедура безболезненна и обычно занимает всего несколько минут на один зуб.",
          "Регулярные осмотры позволяют контролировать целостность герметика.",
        ],
      },
      knirscherschienen: {
        title: "Капы от бруксизма",
        subtitle: "Защита при скрежете зубов",
        cardDescription:
          "Индивидуально подогнанные капы для защиты от износа, напряжения и дискомфорта при сжатии и скрежете зубов.",
        description: [
          "Капы от бруксизма помогают при истирании зубов, а также при скрежете и сжатии зубов. Они защищают зубную ткань и разгружают височно-нижнечелюстной сустав и мускулатуру во время сна.",
          "При частых головных болях, напряжении и болях в области головы и шеи капа может заметно уменьшить симптомы. При обширных керамических реставрациях она также служит дополнительной защитой.",
        ],
        benefits: [
          "Защита от дальнейшего истирания зубов",
          "Разгрузка височно-нижнечелюстного сустава и жевательных мышц",
          "Помощь при головных болях, вызванных бруксизмом",
          "Уменьшение напряжения в области головы и шеи",
          "Защита высококачественных керамических реставраций",
          "Комфорт благодаря индивидуальной подгонке",
        ],
        details: [
          "Капа изготавливается индивидуально для вас и регулярно проверяется.",
          "При необходимости капу можно скорректировать, чтобы она оставалась удобной и хорошо прилегала.",
        ],
      },
      harmonieschiene: {
        title: "Элайнеры",
        subtitle: "Незаметная коррекция зубов",
        cardDescription:
          "Лечение прозрачными капами для бережной коррекции лёгких нарушений прикуса и нарушений средней степени.",
        description: [
          "Элайнеры — это эстетичный способ бережной коррекции лёгких нарушений прикуса и нарушений средней степени. Прозрачные капы практически незаметны в повседневной жизни.",
          "Зубы перемещаются поэтапно с помощью серии кап. Это позволяет постепенно улучшить улыбку без использования классических несъёмных брекетов.",
        ],
        benefits: [
          "Незаметные, прозрачные капы",
          "Бережная коррекция нарушений прикуса",
          "Можно снимать при необходимости",
          "Прогнозируемый ход лечения",
          "Улучшение эстетики улыбки",
          "Комфортная альтернатива несъёмным аппаратам",
        ],
        details: [
          "Подходят ли вам элайнеры, мы выясним на индивидуальной консультации.",
          "В ходе лечения проводятся регулярные контрольные осмотры.",
        ],
      },
      implantate: {
        title: "Имплантаты",
        subtitle: "Несъёмные зубные протезы",
        cardDescription:
          "Искусственные корни зубов, прочно закреплённые в челюстной кости. Естественные ощущения без ограничений.",
        description: [
          "Зубные имплантаты — это искусственные корни зубов, прочно закреплённые в челюстной кости. Они обеспечивают естественные ощущения и не создают ограничений во время еды, разговора или смеха. Используя современные материалы и технологии, мы предлагаем надёжное и долговечное решение.",
          "В отличие от обычных мостов, при имплантации не требуется обтачивание здоровых соседних зубов. Имплантат срастается с костью и обеспечивает прочную опору для коронок, мостов или протезов.",
        ],
        benefits: [
          "Естественные ощущения и внешний вид",
          "Никаких ограничений в повседневной жизни",
          "Сохранение соседних зубов",
          "Долговечность и стабильность",
          "Предотвращение убыли костной ткани",
          "Прочная опора для зубных протезов",
        ],
      },
      bleaching: {
        title: "Отбеливание зубов",
        subtitle: "Осветление зубов",
        cardDescription:
          "Профессиональное осветление зубов до девяти оттенков с возвращением их естественного цвета.",
        description: [
          "С помощью профессионального отбеливания ваши зубы могут стать светлее на девять оттенков. Окрашивания от кофе, чая, красного вина или никотина останутся в прошлом. Зубам вернётся их естественный светлый оттенок.",
          "Мы используем щадящие и проверенные методы отбеливания, не повреждающие зубную эмаль. Результат — сияющая, естественная улыбка.",
        ],
        benefits: [
          "Осветление до девяти оттенков",
          "Щадящее воздействие на зубную эмаль",
          "Естественный результат",
          "Быстро заметный эффект",
          "Индивидуальный подбор оттенка",
          "Длительный результат",
        ],
      },
      veneers: {
        title: "Виниры",
        subtitle: "Керамические виниры",
        cardDescription:
          "Тонкие керамические виниры для идеальной улыбки. Корректируют неровности и небольшие промежутки.",
        description: [
          "Виниры — это тончайшие керамические пластинки, которые фиксируются на передней поверхности зубов. Они позволяют скорректировать неровности, окрашивания, небольшие промежутки и незначительные дефекты положения зубов, создавая безупречную улыбку.",
          "Индивидуально изготовленные виниры надёжно фиксируются с помощью специальной адгезивной технологии. Результат — естественная безупречная улыбка, сохраняющаяся на долгие годы.",
        ],
        benefits: [
          "Идеальный эстетический результат",
          "Тончайшие керамические виниры",
          "Устранение неровностей",
          "Закрытие небольших промежутков между зубами",
          "Естественный результат",
          "Долговечность и светопроницаемость",
        ],
      },
      parodontitis: {
        title: "Лечение пародонтита",
        subtitle: "Здоровье дёсен",
        cardDescription:
          "Ранняя диагностика и специализированное лечение современными методами. Регулярный контроль для оптимальных результатов.",
        description: [
          "Пародонтит — это воспалительное заболевание пародонта, которое без лечения может привести к потере зубов. Благодаря регулярным осмотрам и современным методам лечения мы можем обнаружить и эффективно лечить пародонтит на ранней стадии.",
          "Наше специализированное лечение пародонтита включает тщательную очистку пародонтальных карманов и, при необходимости, хирургические вмешательства. Регулярное наблюдение обеспечивает долгосрочный успех лечения.",
        ],
        benefits: [
          "Раннее выявление благодаря регулярным осмотрам",
          "Современные методы лечения",
          "Тщательная очистка пародонтальных карманов",
          "Сохранение пародонта",
          "Индивидуальное наблюдение",
          "Предотвращение потери зубов",
        ],
      },
      "kronen-bruecken": {
        title: "Коронки и мосты",
        subtitle: "Цельнокерамические протезы",
        cardDescription:
          "Цельнокерамические протезы для естественной эстетики. Стабилизация и восстановление повреждённых зубов.",
        description: [
          "Цельнокерамические коронки и мосты обеспечивают эстетически привлекательное и функционально качественное восстановление. Они стабилизируют и защищают повреждённые зубы и заменяют отсутствующие зубы естественным образом.",
          "Наши цельнокерамические конструкции отличаются превосходной биосовместимостью и естественной светопроницаемостью. Результат — зубы, практически неотличимые от натуральных.",
        ],
        benefits: [
          "Естественная эстетика благодаря цельной керамике",
          "Превосходная биосовместимость",
          "Стабилизация повреждённых зубов",
          "Отсутствие тёмных краёв коронок",
          "Индивидуальный подбор цвета",
          "Долговечная, стабильная реставрация",
        ],
      },
      prothesen: {
        title: "Протезы",
        subtitle: "Частичные и полные протезы",
        cardDescription:
          "Съёмные или комбинированные зубные протезы для надёжного замещения отсутствующих зубов.",
        description: [
          "Зубные протезы — это съёмные или несъёмные конструкции, а также их комбинация, которые подразделяются на частичные и полные протезы.",
          "Частичные протезы заменяют отсутствующие зубы при наличии оставшихся. Полные протезы заменяют весь зубной ряд. Для обеспечения функциональности и долговечности мы рекомендуем регулярные профессиональные осмотры и чистки.",
        ],
        benefits: [
          "Индивидуально подогнанный зубной протез",
          "Возможность частичного или полного восстановления",
          "Восстановление жевательной функции и речи",
          "Улучшение эстетики в повседневной жизни",
          "Надёжная фиксация благодаря точной подгонке",
          "Профессиональный уход и наблюдение",
        ],
        details: [
          "Протезы следует проверять и профессионально чистить не реже двух-трёх раз в год.",
          "Регулярная корректировка повышает комфорт ношения и функциональность.",
        ],
      },
      kunststofffuellungen: {
        title: "Пломбы из композита",
        subtitle: "Композитные пломбы",
        cardDescription:
          "Прочные композитные пломбы, подобранные под цвет зубов, для небольших дефектов передних и боковых зубов.",
        description: [
          "Композитные пломбы могут применяться при небольших дефектах в области передних и боковых зубов, например при кариозных поражениях или сколах режущего края. В нашей клинике мы преимущественно используем высококачественные композитные пломбы для восстановления зубной ткани.",
          "Композит — это материал с керамическими наполнителями, который отличается прочностью, долговечностью и биосовместимостью. Его можно подобрать под цвет натурального зуба, что позволяет провести малоинвазивное лечение.",
        ],
        benefits: [
          "Высокая эстетика благодаря подбору цвета под зуб",
          "Высокая прочность и длительный срок службы",
          "Биосовместимость и хорошая переносимость",
          "Стабилизация за счёт дентинно-адгезивного соединения",
          "Малоинвазивное лечение кариеса",
          "Зубом можно пользоваться сразу после лечения",
        ],
      },
      wurzelbehandlung: {
        title: "Лечение корневых каналов",
        subtitle: "Сохранение зуба эндодонтией",
        cardDescription:
          "Тщательная очистка и дезинфекция всех корневых каналов под местной анестезией. Сохранение зуба вместо удаления.",
        description: [
          "Лечение корневых каналов — это сложная процедура для спасения воспалённого или омертвевшего зуба. Все корневые каналы тщательно очищаются, дезинфицируются и затем пломбируются.",
          "Благодаря современным методам и местной анестезии лечение корневых каналов сегодня практически безболезненно. Наша цель — сохранить ваш естественный зуб и избежать удаления.",
        ],
        benefits: [
          "Сохранение зуба вместо удаления",
          "Безболезненное лечение",
          "Тщательная очистка корневых каналов",
          "Современная дезинфекция",
          "Надёжное герметичное пломбирование каналов",
          "Сохранение естественной зубной ткани",
        ],
      },
      keramikinlays: {
        title: "Керамические вкладки",
        subtitle: "Высококачественные пломбы",
        cardDescription:
          "Индивидуально изготовленная высокотехнологичная керамика, очень похожая на натуральную зубную эмаль. Долговечная и прочная.",
        description: [
          "Керамические вкладки изготавливаются индивидуально из современной керамики, которая по цвету и структуре очень похожа на натуральную зубную эмаль. Они служат эстетичной и долговечной альтернативой обычным пломбам.",
          "Керамика отличается высокой прочностью, биосовместимостью и устойчивостью к изменению цвета. Благодаря точной подгонке зуб надёжно защищён, а его естественная форма восстанавливается.",
        ],
        benefits: [
          "Натуральный вид, как у настоящей зубной эмали",
          "Высокопрочная керамика",
          "Точная индивидуальная подгонка",
          "Биосовместимость и гипоаллергенность",
          "Устойчивость к изменению цвета",
          "Долговечность и износостойкость",
        ],
      },
    },
  },
  team: {
    ...de.team,
    eyebrow: "Наша команда",
    title: "Ваши стоматологи",
    description:
      "Как слаженная команда матери и дочери, мы объединяем многолетний опыт с современными подходами к лечению.",
    members: [
      {
        name: "д-р Иванка Барашка",
        role: "Стоматолог — основатель клиники",
        specialties: [
          "Пародонтология",
          "Имплантология",
          "Эстетическая стоматология",
        ],
        initials: "IB",
        description:
          "С 2003 года д-р Иванка Барашка руководит клиникой с большой отдачей и профессионализмом. Её специализации — пародонтология, эндодонтология и эстетическая стоматология.",
      },
      {
        name: "Красимира Барашка",
        role: "Стоматолог",
        specialties: [
          "Терапевтическая стоматология",
          "Эндодонтология",
          "Профилактика",
        ],
        initials: "KB",
        description:
          "Красимира Барашка применяет щадящий, ориентированный на пациента подход. Пациенты особенно ценят её внимательное отношение к тем, кто испытывает страх перед лечением.",
      },
    ],
  },
  testimonials: {
    ...de.testimonials,
    eyebrow: "Отзывы",
    title: "Что говорят наши пациенты",
    description:
      "Мы ценим доверие наших пациентов. Узнайте, что они говорят о нашей клинике.",
    ratingLabel: "Оценки на Jameda",
    items: [
      {
        text: "До этого я долго не посещал стоматолога и боялся лечения. Благодаря приветливому коллективу клиники страх остался в прошлом. Теперь моя мама тоже стала пациенткой клиники.",
        date: "Июнь 2022",
        source: "Jameda",
      },
      {
        text: "Редко лечение проходило настолько бережно — укол почти не ощущался! Здесь не навязывают лишние процедуры и стремятся сохранить естественные зубы.",
        date: "Июнь 2020",
        source: "Jameda",
      },
      {
        text: "Быстро, профессионально и тщательно мне вернули красивую улыбку! Я полностью доверился команде и сделал правильный выбор.",
        date: "Июль 2021",
        source: "Jameda",
      },
      {
        text: "Я хожу к доктору Барашке уже около десяти лет и доволен во всех отношениях. Она всегда уделяет достаточно времени и работает качественно и безболезненно.",
        date: "Август 2019",
        source: "Jameda",
      },
      {
        text: "Со мной обращались очень доброжелательно. Обе стоматолога подробно ответили на мои вопросы о рисках, связанных с зубами мудрости в старшем возрасте, не оказывая давления при принятии решения.",
        date: "Январь 2022",
        source: "Jameda",
      },
      {
        text: "Она всегда уделяет достаточно времени, заботится о сохранении каждого зуба и работает очень тщательно.",
        date: "Март 2016",
        source: "Jameda",
      },
    ],
  },
  cta: {
    ...de.cta,
    title: "Ваша самая красивая улыбка ждёт вас",
    description:
      "Запишитесь на приём сегодня и получите ни к чему не обязывающую консультацию. Мы уделим вам достаточно времени.",
  },
  contact: {
    ...de.contact,
    eyebrow: "Контакты",
    title: "Как с нами связаться",
    description:
      "Будем рады вашему визиту. Запишитесь на приём по телефону или посетите нашу клинику на улице Цайль.",
    cardTitle: "Контактные данные",
    addressLabel: "Адрес",
    addressLine1: "Zeil 81 (вход Holzgraben)",
    addressHint: "2-й этаж, есть лифт и доступ для маломобильных посетителей",
    phoneLabel: "Телефон",
    emailLabel: "Эл. почта",
    hoursTitle: "Часы работы",
    hours: [
      { day: "Понедельник", hours: "8:00 - 18:00" },
      { day: "Вторник", hours: "8:00 - 18:00" },
      { day: "Среда", hours: "8:00 - 19:00" },
      { day: "Четверг", hours: "8:00 - 18:00" },
      { day: "Пятница", hours: "8:00 - 13:00" },
      { day: "Суббота", hours: "Закрыто", closed: true },
      { day: "Воскресенье", hours: "Закрыто", closed: true },
    ],
    emergency:
      "Неотложная помощь: дежурная врачебная служба — 116117. При угрозе жизни звоните по номеру 112.",
  },
  footer: {
    ...de.footer,
    description:
      "С 2003 года — ваша надёжная стоматология в центре Франкфурта. Современное лечение с заботой и профессионализмом.",
    servicesHeading: "Услуги",
    openingHoursHeading: "Часы работы",
    contactHeading: "Контакты",
    openingSummary: [
      { day: "Пн, Вт, Чт", hours: "8:00 - 18:00" },
      { day: "Среда", hours: "8:00 - 19:00" },
      { day: "Пятница", hours: "8:00 - 13:00" },
      { day: "Сб, Вс", hours: "Закрыто", closed: true },
    ],
  },
  servicePage: {
    ...de.servicePage,
    appointmentTitle: "Записаться на приём",
    appointmentDescription:
      "Мы подробно проконсультируем вас по поводу этой процедуры. Позвоните нам или посетите нашу клинику.",
  },
  legal: {
    impressum: {
      title: "Юридическая информация",
      sections: [
        {
          title: "Сведения согласно § 5 TMG",
          body: [
            "Zahnarztpraxis Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
            "Zeil 81 (Eingang Holzgraben)",
            "60313 Frankfurt am Main",
          ],
        },
        {
          title: "Контакт",
          body: [
            "Телефон: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "Профессиональное звание",
          body: [
            "Врач-стоматолог (присвоено в Федеративной Республике Германия)",
            "Компетентная палата: Государственная стоматологическая палата Гессена",
            "Компетентный надзорный орган: Ассоциация стоматологов системы обязательного медицинского страхования Гессена",
          ],
        },
        {
          title: "Профессиональные правовые нормы",
          body: [
            "Закон о стоматологии (ZHG)",
            "Профессиональный кодекс Государственной стоматологической палаты Гессена",
            "Тарифный сборник для стоматологов (GOZ)",
          ],
        },
      ],
    },
    datenschutz: {
      title: "Политика конфиденциальности",
      sections: [
        {
          title: "1. Ответственное лицо",
          body: [
            "Ответственным за обработку данных на этом сайте является:",
            "Dr. med. dent. Ivanka Barashka",
            "Zeil 81 (Eingang Holzgraben), 60313 Frankfurt am Main",
            "Телефон: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "2. Сбор и хранение персональных данных",
          body: [
            "При посещении нашего сайта браузер автоматически передаёт информацию, которая сохраняется в лог-файлах сервера. Эти данные не связываются с конкретными лицами и не объединяются с другими источниками данных.",
          ],
        },
        {
          title: "3. Связь с нами",
          body: [
            "Если вы связываетесь с нами по телефону или электронной почте, ваши данные сохраняются для обработки вашего запроса. Передача третьим лицам не осуществляется.",
          ],
        },
        {
          title: "4. Ваши права",
          body: [
            "Вы имеете право на получение информации, исправление, удаление и ограничение обработки ваших персональных данных. Пожалуйста, обратитесь по указанному выше адресу.",
          ],
        },
        {
          title: "5. Google Maps",
          body: [
            "Этот сайт использует Google Maps для отображения нашего местоположения. При загрузке данные передаются в Google. Дополнительную информацию можно найти в политике конфиденциальности Google.",
          ],
        },
      ],
    },
  },
}

const bg = {
  ...de,
  meta: {
    ...de.meta,
    homeTitle: "Дентална практика д-р Иванка Барашка | Франкфурт на Майн",
    homeDescription:
      "Модерна дентална практика в центъра на Франкфурт. Безболезнено лечение, естетична стоматология, имплантология и още много услуги.",
    impressumTitle: "Правна информация | Дентална практика д-р Барашка",
    datenschutzTitle:
      "Политика за поверителност | Дентална практика д-р Барашка",
    serviceTitle: "{{title}} | Дентална практика д-р Барашка, Франкфурт",
  },
  brand: {
    ...de.brand,
    doctorName: "д-р Иванка Барашка",
    subtitle: "Дентална практика Франкфурт",
    footerSubtitle: "Дентална практика Франкфурт на Майн",
  },
  nav: {
    practice: "За практиката",
    services: "Услуги",
    team: "Екип",
    testimonials: "Отзиви",
    contact: "Контакт",
  },
  common: {
    ...de.common,
    bookAppointment: "Запазете час",
    learnMore: "Научете повече",
    allServices: "Всички услуги",
    callNow: "Обадете се сега",
    contactNow: "Свържете се с нас",
    languageLabel: "Език",
    rightsReserved: "Всички права запазени.",
    moreServices: "Още услуги",
    advantages: "Вашите предимства",
    showAll: "Покажете всички",
  },
  hero: {
    ...de.hero,
    eyebrow: "От 2003 г. във Франкфурт на Майн",
    titlePrefix: "Добре дошли в",
    titleHighlight: "екип Барашка",
    description:
      "Тук опитът среща иновациите в съвършена комбинация. Вашето дентално здраве е в сигурни ръце — с внимание, без болка и с най-съвременни методи.",
    badges: [
      "Пациентите със страх от зъболекар са добре дошли",
      "Безболезнено лечение",
      "Многоезична практика",
    ],
  },
  about: {
    ...de.about,
    eyebrow: "За практиката",
    title: "Вашето дентално здраве е в най-добрите ръце",
    paragraphs: [
      "Нашата практика е основана на 1 октомври 2003 г. Оттогава се стремим да помагаме на всички пациенти възможно най-бързо и да ги лекуваме с най-добрите и най-съвременни методи.",
      "Нашата дентална практика е специализирана във внимателно, щадящо и безболезнено лечение, така че всеки пациент да се чувства добре при нас. Отдаваме голямо значение на естетичната стоматология и предлагаме най-високо качество в областта на профилактиката, запазването на зъбите, имплантологията и цялокерамичното протезиране.",
      "За нас е естествено и децата да бъдат лекувани по приятен за тях начин, без болка и страх.",
    ],
    experienceLabel: "Години опит",
    features: [
      {
        id: "heart",
        title: "Внимателно лечение",
        description:
          "Специализирани сме в безболезнено лечение, особено за пациенти с дентален страх.",
      },
      {
        id: "sparkles",
        title: "Съвременни методи",
        description:
          "Иновативни технологии и висококачествени материали за най-добри резултати.",
      },
      {
        id: "shield",
        title: "Най-високо качество от 2003 г.",
        description:
          "Над 20 години опит в зъбна естетика, имплантология и протетика.",
      },
      {
        id: "globe",
        title: "Многоезична практика",
        description: "Говорим немски, английски, руски и български.",
      },
    ],
  },
  services: {
    ...de.services,
    eyebrow: "Услуги",
    title: "Спектърът на нашите услуги",
    description:
      "От профилактиката до имплантологията — предлагаме пълен спектър от съвременни дентални услуги.",
    items: {
      zahnreinigung: {
        title: "Професионално почистване на зъбите",
        subtitle: "Профилактика и превенция",
        cardDescription:
          "Основна част от индивидуалната профилактика на кариес и пародонтит с ултразвук и AirFlow.",
        description: [
          "Професионалното почистване на зъбите (PZR) е основна част от индивидуалната профилактика на кариес и пародонтит. С помощта на ултразвук и AirFlow се отстраняват упорити отлагания и оцветявания, които не могат да бъдат премахнати при ежедневното миене на зъбите.",
          "Резултатът е усещане за чисти и свежи зъби. Редовното професионално почистване допринася значително за поддържане на денталното здраве и може да предотврати скъпоструващи лечения.",
        ],
        benefits: [
          "Премахване на зъбен камък и отлагания",
          "Предотвратяване на кариес и пародонтит",
          "Почистване с ултразвук и AirFlow",
          "Полиране и флуоридна обработка",
          "Индивидуална консултация за орална хигиена",
          "Свежо, чисто усещане в устата",
        ],
        details: [
          "Препоръчваме професионално почистване на зъбите поне два пъти годишно.",
          "Процедурата обикновено отнема 45-60 минути и е безболезнена.",
        ],
      },
      zahnversiegelung: {
        title: "Запечатване на фисури",
        subtitle: "Профилактика на кариес",
        cardDescription:
          "Покриване на зъбните фисури с тънък слой стоматологичен силант за защита от кариес.",
        description: [
          "Запечатването на фисури представлява покриване на зъбите с тънък слой стоматологичен силант за защита от кариес. Обикновено се запечатват фисурите — вдлъбнатините по дъвкателната повърхност.",
          "За разлика от пломбирането, запечатването се прилага превантивно, преди да е възникнал кариозен дефект на зъба. Така особено податливите на кариес области се защитават дългосрочно.",
        ],
        benefits: [
          "Ефективна защита на зъбните фисури",
          "Предотвратяване на кариес",
          "Бърза и щадяща процедура",
          "Особено подходящо за деца и юноши",
          "Запазване на здравата зъбна субстанция",
          "Дългосрочна профилактика",
        ],
        details: [
          "Процедурата е безболезнена и обикновено отнема само няколко минути на зъб.",
          "Редовните прегледи гарантират, че запечатването остава непокътнато.",
        ],
      },
      knirscherschienen: {
        title: "Шини против скърцане",
        subtitle: "Защита при скърцане на зъби",
        cardDescription:
          "Индивидуално пригодени шини за защита от износване, напрежение и дискомфорт при стискане и скърцане на зъби.",
        description: [
          "Шините против скърцане помагат при износване на зъбите, както и при скърцане или стискане на зъби. Те защитават зъбната субстанция и облекчават челюстната става и мускулатурата през нощта.",
          "При чести главоболия, напрежение и болки в областта на главата и шията шината може забележимо да намали оплакванията. При обширни керамични възстановявания тя служи и като допълнителна защита.",
        ],
        benefits: [
          "Защита от по-нататъшно износване на зъбите",
          "Облекчаване на челюстната става и дъвкателните мускули",
          "Подкрепа при главоболие, причинено от бруксизъм",
          "Намаляване на напрежението в областта на главата и шията",
          "Предпазване на висококачествени керамични възстановявания",
          "Комфорт благодарение на индивидуалната изработка",
        ],
        details: [
          "Шината се изработва индивидуално за вас и се контролира редовно.",
          "При необходимост шината може да се коригира, за да приляга удобно и занапред.",
        ],
      },
      harmonieschiene: {
        title: "Прозрачни алайнери",
        subtitle: "Незабележима корекция на зъбите",
        cardDescription:
          "Лечение с прозрачни шини за щадяща корекция на леки и умерени зъбни неправилности.",
        description: [
          "Прозрачните алайнери са естетичен начин за щадяща корекция на леки и умерени зъбни неправилности. Те са почти незабележими в ежедневието.",
          "Зъбите се преместват поетапно чрез поредица от шини. Така усмивката може да бъде постепенно подобрена без използването на класически фиксирани брекети.",
        ],
        benefits: [
          "Незабележими, прозрачни шини",
          "Щадяща корекция на зъбни неправилности",
          "Свалящи се в ежедневието",
          "Предвидим ход на лечението",
          "Подобрена естетика на усмивката",
          "Удобна алтернатива на фиксирани апарати",
        ],
        details: [
          "По време на индивидуална консултация ще преценим дали алайнерите са подходящи за вас.",
          "Редовни контролни прегледи съпътстват хода на терапията.",
        ],
      },
      implantate: {
        title: "Импланти",
        subtitle: "Фиксирано зъбно протезиране",
        cardDescription:
          "Изкуствени зъбни корени, здраво закрепени в челюстната кост. Естествено усещане без ограничения.",
        description: [
          "Зъбните импланти са изкуствени зъбни корени, които се закрепват здраво в челюстната кост. Те осигуряват естествено усещане и никакви ограничения при хранене, говорене или смях. С най-съвременни материали и техники осигуряваме безопасно и дълготрайно решение.",
          "За разлика от конвенционалните мостове, при имплантите не е необходимо изпиляване на здрави съседни зъби. Имплантът сраства с костта и осигурява здраво задържане за коронки, мостове или протези.",
        ],
        benefits: [
          "Естествено усещане и външен вид",
          "Без ограничения в ежедневието",
          "Запазване на съседните зъби",
          "Дълготрайност и стабилност",
          "Предотвратяване на костна загуба",
          "Стабилна опора за зъбни възстановявания",
        ],
      },
      bleaching: {
        title: "Избелване на зъби",
        subtitle: "Професионално избелване",
        cardDescription:
          "Професионално избелване на зъби с до девет нюанса. Зъбите възвръщат първоначалния си цвят.",
        description: [
          "С професионалното избелване вашите зъби могат да бъдат избелени с до девет нюанса. Оцветяванията от кафе, чай, червено вино или никотин остават в миналото. Зъбите ви възвръщат първоначалния си, естествено светъл цвят.",
          "Използваме щадящи и доказани методи за избелване, които не увреждат зъбния емайл. Резултатът е сияйна, естествено изглеждаща усмивка.",
        ],
        benefits: [
          "Избелване с до девет нюанса",
          "Щадящо за зъбния емайл",
          "Естествено изглеждащ резултат",
          "Бързо видими резултати",
          "Индивидуален избор на нюанс",
          "Дълготраен ефект",
        ],
      },
      veneers: {
        title: "Фасети (венири)",
        subtitle: "Керамични фасети",
        cardDescription:
          "Много тънки керамични фасети за перфектна усмивка. Коригират неравности и малки междини.",
        description: [
          "Фасетите (венирите) са много тънки керамични пластини, които се поставят върху предната повърхност на зъбите. Те са идеално решение за коригиране на неравности, оцветявания, малки междини или леки неправилности и за създаване на красива усмивка.",
          "Индивидуално изработените фасети се закрепват трайно чрез специална адхезивна техника. Резултатът е естествено изглеждаща, безупречна усмивка, която се запазва години наред.",
        ],
        benefits: [
          "Перфектен естетически резултат",
          "Много тънки керамични пластини",
          "Коригиране на неравности",
          "Затваряне на малки междузъбни пространства",
          "Естествено изглеждащ резултат",
          "Дълготрайност и светлопропускливост",
        ],
      },
      parodontitis: {
        title: "Лечение на пародонтит",
        subtitle: "Здраве на венците",
        cardDescription:
          "Ранно откриване и специализирано лечение с модерни методи. Редовен контрол за оптимални резултати.",
        description: [
          "Пародонтитът е възпалително заболяване на зъбодържащия апарат, което нелекувано може да доведе до загуба на зъби. Чрез редовни контролни прегледи и модерни методи на лечение можем да открием и ефективно да лекуваме пародонтита навреме.",
          "Нашето специализирано лечение на пародонтит включва щателно почистване на пародонталните джобове и при необходимост хирургични интервенции. Редовното проследяване осигурява дългосрочния успех на лечението.",
        ],
        benefits: [
          "Ранно откриване чрез редовни прегледи",
          "Модерни методи на лечение",
          "Щателно почистване на пародонталните джобове",
          "Запазване на зъбодържащия апарат",
          "Индивидуално проследяване",
          "Предотвратяване на загуба на зъби",
        ],
      },
      "kronen-bruecken": {
        title: "Коронки и мостове",
        subtitle: "Цялокерамични конструкции",
        cardDescription:
          "Цялокерамични конструкции с естествена естетика за стабилизиране и възстановяване на увредени зъби.",
        description: [
          "Изцяло керамичните коронки и мостове осигуряват естетически привлекателно и функционално висококачествено възстановяване. Те стабилизират и защитават увредени зъби и заместват липсващи зъби по естествен начин.",
          "Нашите цялокерамични конструкции се отличават с отлична биосъвместимост и естествена светлопропускливост. Резултатът са зъби, почти неразличими от естествените.",
        ],
        benefits: [
          "Естествена естетика с цялокерамични конструкции",
          "Отлична биосъвместимост",
          "Стабилизиране на увредени зъби",
          "Без тъмни ръбове на коронките",
          "Индивидуално цветово съгласуване",
          "Дълготрайно, стабилно възстановяване",
        ],
      },
      prothesen: {
        title: "Протези",
        subtitle: "Частични и пълни протези",
        cardDescription:
          "Подвижни или комбинирани протези за надеждно заместване на липсващи зъби.",
        description: [
          "Зъбните протези са подвижни или фиксирани зъбни заместители, или комбинация от двете, и се разделят на частични и пълни протези.",
          "Частичните протези заместват липсващи зъби при наличие на запазени собствени зъби. Пълните протези заместват цялата зъбна редица. За функционалност и дълготрайност препоръчваме редовни професионални прегледи и почиствания.",
        ],
        benefits: [
          "Индивидуално изработени зъбни протези",
          "Възможно частично или пълно възстановяване",
          "Възстановяване на дъвкателната функция и говора",
          "Подобрена естетика в ежедневието",
          "Сигурно задържане чрез прецизна изработка",
          "Професионална грижа и проследяване",
        ],
        details: [
          "Протезите трябва да се проверяват и професионално почистват поне два до три пъти годишно.",
          "Редовните корекции повишават комфорта на носене и функционалността.",
        ],
      },
      kunststofffuellungen: {
        title: "Композитни пломби",
        subtitle: "Пломби от композит",
        cardDescription:
          "Стабилни композитни пломби с цвят, съответстващ на естествените зъби, за по-малки дефекти.",
        description: [
          "Композитните пломби могат да се прилагат при по-малки дефекти в областта на предните и страничните зъби, например при кариозни дефекти или отчупени ръбове. В нашата практика използваме предимно висококачествени композитни пломби за възстановяване на зъбната тъкан.",
          "Композитът е пластмасов материал, подсилен с керамични частици, който е здрав, издръжлив и биосъвместим. Материалът може да се подбере според цвета на естествения зъб и позволява минимално инвазивно лечение.",
        ],
        benefits: [
          "Висока дентална естетика чрез цветово съгласуване",
          "Висока здравина и дълготрайност",
          "Биосъвместим и добре поносим",
          "Стабилизация чрез дентин-адхезивна връзка",
          "Минимално инвазивно лечение на кариес",
          "Може да се натоварва веднага след лечението",
        ],
      },
      wurzelbehandlung: {
        title: "Лечение на коренови канали",
        subtitle: "Запазване на зъба чрез ендодонтия",
        cardDescription:
          "Щателно почистване и дезинфекция на всички коренови канали под местна упойка. Запазване на зъба вместо изваждане.",
        description: [
          "Лечението на коренови канали е сложна процедура за спасяване на възпален или мъртъв зъб. Всички коренови канали се почистват щателно, дезинфекцират и след това се запечатват.",
          "Благодарение на съвременните техники и местната упойка лечението на коренови канали днес е почти безболезнено. Нашата цел е да запазим вашия естествен зъб и да избегнем изваждането му.",
        ],
        benefits: [
          "Запазване на зъба вместо изваждане",
          "Безболезнено лечение",
          "Щателно почистване на кореновите канали",
          "Модерна дезинфекция",
          "Трайно запечатване",
          "Запазване на естествената зъбна субстанция",
        ],
      },
      keramikinlays: {
        title: "Керамични инлеи",
        subtitle: "Висококачествени зъбни пломби",
        cardDescription:
          "Индивидуално изработена високотехнологична керамика, много подобна на естествения зъбен емайл. Дълготрайна и стабилна.",
        description: [
          "Керамичните инлеи са индивидуално изработени вложки от високотехнологична керамика, които по цвят и структура много наподобяват естествения зъбен емайл. Те предлагат естетически превъзходна и дълготрайна алтернатива на конвенционалните пломби.",
          "Керамиката е особено стабилна, биосъвместима и не променя цвета си. Чрез прецизното пасване зъбът е оптимално защитен и естествената му форма е възстановена.",
        ],
        benefits: [
          "Естествен вид като истински зъбен емайл",
          "Високоустойчива керамика",
          "Прецизно, индивидуално пасване",
          "Добра биосъвместимост и поносимост",
          "Без промяна на цвета",
          "Дълготрайност и устойчивост",
        ],
      },
    },
  },
  team: {
    ...de.team,
    eyebrow: "Нашият екип",
    title: "Вашите зъболекари",
    description:
      "Като добре сработен екип от майка и дъщеря, ние съчетаваме десетилетия опит със съвременни подходи към лечението.",
    members: [
      {
        name: "д-р Иванка Барашка",
        role: "Зъболекар — основател на практиката",
        specialties: [
          "Пародонтология",
          "Имплантология",
          "Естетична стоматология",
        ],
        initials: "IB",
        description:
          "От 2003 г. д-р Иванка Барашка ръководи практиката с отдаденост и професионализъм. Нейните специализации са пародонтология, ендодонтология и естетична стоматология.",
      },
      {
        name: "Красимира Барашка",
        role: "Зъболекар",
        specialties: [
          "Консервативна стоматология",
          "Ендодонтология",
          "Профилактика",
        ],
        initials: "KB",
        description:
          "Красимира Барашка допълва екипа с щадящо, ориентирано към пациента лечение. Пациентите я ценят особено за внимателния ѝ подход към хората с дентален страх.",
      },
    ],
  },
  testimonials: {
    ...de.testimonials,
    eyebrow: "Отзиви",
    title: "Какво казват нашите пациенти",
    description:
      "Ценим доверието на нашите пациенти. Прочетете какво споделят те за нашата практика.",
    ratingLabel: "Оценено в Jameda",
    items: [
      {
        text: "Дълго време не бях посещавал зъболекар, защото се страхувах. Благодарение на приветливия екип в практиката този страх вече е в миналото. Сега и майка ми е пациентка тук.",
        date: "Юни 2022",
        source: "Jameda",
      },
      {
        text: "Рядко са се отнасяли толкова внимателно с мен — убождането почти не се усещаше! Тя не е от зъболекарите, които ненужно предлагат допълнителни процедури, и се стреми да запази естествените зъби.",
        date: "Юни 2020",
        source: "Jameda",
      },
      {
        text: "Бързо, професионално и внимателно ми върнаха красивата усмивка! Напълно им се доверих и взех правилното решение.",
        date: "Юли 2021",
        source: "Jameda",
      },
      {
        text: "Ходя при д-р Барашка вече около десет години и съм напълно доволен във всяко отношение. Тя винаги отделя достатъчно време и работи качествено и безболезнено.",
        date: "Август 2019",
        source: "Jameda",
      },
      {
        text: "Отнесоха се с мен много любезно. Двете зъболекарки обсъдиха подробно въпросите ми за рисковете, свързани с мъдреците в напреднала възраст, без да ме притискат да взема решение.",
        date: "Януари 2022",
        source: "Jameda",
      },
      {
        text: "Винаги отделя достатъчно време, грижи се за запазването на всеки зъб и работи много старателно.",
        date: "Март 2016",
        source: "Jameda",
      },
    ],
  },
  cta: {
    ...de.cta,
    title: "Вашата най-красива усмивка ви очаква",
    description:
      "Запазете своя час още днес и получете неангажираща консултация. Отделяме достатъчно време за вас.",
  },
  contact: {
    ...de.contact,
    eyebrow: "Контакт",
    title: "Как да се свържете с нас",
    description:
      "Ще се радваме да ни посетите. Запазете час по телефона или елате директно в нашата практика на улица Цайл.",
    cardTitle: "Данни за контакт",
    addressLabel: "Адрес",
    addressLine1: "Zeil 81 (вход Holzgraben)",
    addressHint:
      "2-ри етаж с асансьор, достъпно за хора с ограничена подвижност",
    phoneLabel: "Телефон",
    emailLabel: "Имейл",
    hoursTitle: "Работно време",
    hours: [
      { day: "Понеделник", hours: "8:00 - 18:00" },
      { day: "Вторник", hours: "8:00 - 18:00" },
      { day: "Сряда", hours: "8:00 - 19:00" },
      { day: "Четвъртък", hours: "8:00 - 18:00" },
      { day: "Петък", hours: "8:00 - 13:00" },
      { day: "Събота", hours: "Затворено", closed: true },
      { day: "Неделя", hours: "Затворено", closed: true },
    ],
    emergency:
      "Неотложна помощ: дежурна медицинска служба — 116117. При опасност за живота се обадете на 112.",
  },
  footer: {
    ...de.footer,
    description:
      "От 2003 г. вашата надеждна дентална практика в сърцето на Франкфурт. Модерна дентална медицина със сърце и разум.",
    servicesHeading: "Услуги",
    openingHoursHeading: "Работно време",
    contactHeading: "Контакт",
    openingSummary: [
      { day: "Пн, Вт, Чт", hours: "8:00 - 18:00" },
      { day: "Сряда", hours: "8:00 - 19:00" },
      { day: "Петък", hours: "8:00 - 13:00" },
      { day: "Сб, Нд", hours: "Затворено", closed: true },
    ],
  },
  servicePage: {
    ...de.servicePage,
    appointmentTitle: "Запазете час",
    appointmentDescription:
      "С удоволствие ще ви консултираме подробно за тази процедура. Обадете ни се или ни посетете в нашата практика.",
  },
  legal: {
    impressum: {
      title: "Правна информация",
      sections: [
        {
          title: "Данни съгласно § 5 TMG",
          body: [
            "Zahnarztpraxis Dr. med. dent. Ivanka Barashka und Krassimira Baraschka",
            "Zeil 81 (Eingang Holzgraben)",
            "60313 Frankfurt am Main",
          ],
        },
        {
          title: "Контакт",
          body: [
            "Телефон: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "Професионално звание",
          body: [
            "Зъболекар (придобито във Федерална република Германия)",
            "Компетентна камара: Държавна дентална камара на Хесен",
            "Компетентен надзорен орган: Асоциация на зъболекарите по задължително здравно осигуряване в Хесен",
          ],
        },
        {
          title: "Професионални правни норми",
          body: [
            "Закон за упражняване на денталната медицина (ZHG)",
            "Кодекс на Държавната дентална камара на Хесен",
            "Наредба за таксите за зъболекари (GOZ)",
          ],
        },
      ],
    },
    datenschutz: {
      title: "Политика за поверителност",
      sections: [
        {
          title: "1. Отговорно лице",
          body: [
            "Отговорното лице за обработката на данни на този уебсайт е:",
            "Dr. med. dent. Ivanka Barashka",
            "Zeil 81 (Eingang Holzgraben), 60313 Frankfurt am Main",
            "Телефон: 069 28 76 50",
            "E-Mail: info@zahnarztpraxis-barashka.de",
          ],
        },
        {
          title: "2. Събиране и съхранение на лични данни",
          body: [
            "При посещение на нашия уебсайт браузърът автоматично предава информация, която се съхранява в лог-файловете на сървъра. Тези данни не могат да бъдат свързани с конкретни лица и не се обединяват с други източници на данни.",
          ],
        },
        {
          title: "3. Контакт",
          body: [
            "Ако се свържете с нас по телефона или имейл, вашите данни ще бъдат съхранени за обработка на вашето запитване. Данните не се предоставят на трети лица.",
          ],
        },
        {
          title: "4. Вашите права",
          body: [
            "Имате право на достъп, коригиране, изтриване и ограничаване на обработката на личните ви данни. Моля, свържете се с посочения по-горе адрес.",
          ],
        },
        {
          title: "5. Google Maps",
          body: [
            "Този уебсайт използва Google Maps за показване на нашето местоположение. При зареждането данни се изпращат до Google. Повече информация можете да намерите в политиката за поверителност на Google.",
          ],
        },
      ],
    },
  },
}

export const defaultLanguage = "de"

export const translations = {
  de,
  en,
  ru,
  bg,
}

export const languageOptions = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "ru", label: "Русский" },
  { code: "bg", label: "Български" },
]

export const supportedLanguages = Object.keys(translations)
